import { LabResultsContent } from './LabResultsContent'

const LabResults = () => {
    return <LabResultsContent />
}

export default LabResults
